import type { Permission, Scope } from '../api/types/permissions';

// Mismas familias que el rbac prohíbe a un usuario de API; las excepciones no administran nada.
const API_USER_FORBIDDEN_PREFIXES = [
    'tenant.',
    'platform.',
    'rbac.',
    'level1.',
    'level2.',
    'level3.',
];
const API_USER_ALLOWED_PERMISSIONS: ReadonlySet<string> = new Set([
    'tenant.integration.diagnostic',
]);

export function isApiUserForbiddenPermission(permission: string): boolean {
    if (API_USER_ALLOWED_PERMISSIONS.has(permission)) return false;
    return API_USER_FORBIDDEN_PREFIXES.some((prefix) => permission.startsWith(prefix));
}

/** true si el rol es de administración o de plataforma. Sin permisos en el listado no se bloquea. */
export function isRoleForbiddenForApiUser(role: {
    scope?: Scope;
    permissions?: readonly string[];
}): boolean {
    if (role.scope === 'PLATFORM') return true;
    return (role.permissions ?? []).some(isApiUserForbiddenPermission);
}

/** Explicación junto a un rol que un sistema (API) no puede recibir. */
export const API_ROLE_DISABLED_NOTE = 'No disponible para sistemas';

/** Permiso que administra usuarios de API; el openapi generado aún no lo trae en su catálogo. */
export const API_USER_MANAGE_PERMISSION = 'tenant.api_user.manage' as Permission;
